export const GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID = 'fundingApplicationId';
export const GLOBAL_KEY_APPROVE_ME_FUNDING_APP = 'fundingApplication';
export const GLOBAL_KEY_APPROVE_ME_FUNDING_RESULT = 'fundingApplicationResult';
export const GLOBAL_KEY_APPROVE_ME_APPROVAL_AMOUNT = 'approvalAmount';
export const GLOBAL_KEY_APPROVE_ME_CUSTOMER_FIRST_NAME = 'customerFirstName';
